<template>
  <b-sidebar
    title="Хэрэглэгч тохируулах"
    v-model="showSidebar"
    @change="visibleChanged"
    width="100vw"
    right
  >
    <div class="bg-white">
      <div class="row no-gutters">
        <div class="col-4">
          <div class="d-flex pd-5">
            <div class="input-group">
              <div class="input-group-prepend">
                <button class="btn btn-icon btn-outline-light btn-xs">
                  <feather type="filter"></feather>
                </button>
              </div>
              <input
                placeholder="Хайх"
                v-model="filterDepart"
                class="form-control"
                style="width: auto"
              />
              <div class="input-group-append">
                <button
                  @click="
                    filterParam.userIds = [];
                    filterDepart = '';
                    filterParam.userDepCur = null;
                  "
                  v-if="filterParam.userIds.length || filterDepart.length"
                  class="btn btn-icon btn-outline-light btn-xs mg-l-auto"
                >
                  <feather type="x"></feather>
                </button>
              </div>
            </div>
          </div>
          <div class="pos-relative">
            <!-- <vue-custom-scrollbar
            :style="`height:calc(100vh - 160px);`"
            :settings="{maxScrollbarLength: 60}"
          > -->
            <div style="height:calc(60vh - 200px); overflow: auto">

              <!--  -->
              <div class="divider divider-text">Төлөв</div>
              <Tree :data="locTypeList4" @current-change="handleStateSelect"></Tree>
              <div class="divider divider-text">Нэгж</div>
              <Tree
                ref="departTree"
                :filter-node-method="filterNode"
                node-key="id"
                node-key1="label"
                :data="departs"
                :props="defaultProps"
                highlight-current
                auto-expand-parent
                accordion
                class="depart-tree pd-10"
              >
                <div
                  @click="departNodeClicked(node.key)"
                  slot-scope="{ node }"
                  class="d-flex align-items-center wd-100p"
                >
                  <div class="tx-color-02">
                    {{ node.label }}
                  </div>
                  <div class="btn-group mg-l-auto">
                    <button
                      @click.stop="addGroup(node.key)"
                      type="button"
                      class="btn btn-outline-light btn-xs btn-icon"
                    >
                      <feather type="plus" class=""></feather>
                    </button>
                    <button
                      @click.stop="removeGroup(node.key)"
                      type="button"
                      class="btn btn-outline-light btn-xs btn-icon"
                    >
                      <feather type="minus" class=""></feather>
                    </button>
                  </div>
                </div>
              </Tree>
            </div>
            <!-- </vue-custom-scrollbar> -->
          </div>
          <ul class="nav nav-line nav-justified">
            <li class="nav-item">
              <a
                @click="dnmcSrchAll(1)"
                class="nav-link"
                :class="{ active: dnmcSrch.activeTab == 1 }"
                role="button"
              >
                Нэмэх боломжтой хэрэглэгчдээс хайх
              </a>
            </li>
            <li class="nav-item">
              <a
                @click="dnmcSrchAll(2)"
                class="nav-link"
                :class="{ active: dnmcSrch.activeTab == 2 }"
                role="button"
              >
                Нэмсэн хэрэглэгчдээс хайх
              </a>
            </li>
          </ul>
          <div style="height:40vh; overflow: auto" class="pd-x-20 pd-y-10">
            <div class="pd-x-10">
              <div class="form-group row mg-b-5-f">
                <label
                  class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03"
                  >Гишүүн №</label
                >
                <div class="col-sm-8 pd-0">
                  <input
                    v-on:keyup="checkEnter"
                    v-model="dnmcSrch.un"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label
                  class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03"
                  >Овог</label
                >
                <div class="col-sm-8 pd-0">
                  <input
                    v-on:keyup="checkEnter"
                    v-model="dnmcSrch.ln"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label
                  class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03"
                  >Нэр</label
                >
                <div class="col-sm-8 pd-0">
                  <input
                    v-on:keyup="checkEnter"
                    v-if="dnmcSrch.activeTab == 1"
                    v-model="filterParamUserTemp"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                  <input
                    v-on:keyup="checkEnter"
                    v-else-if="dnmcSrch.activeTab == 2"
                    v-model="filterParamMemberTemp"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label
                  class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03"
                  >Албан тушаал</label
                >
                <div class="col-sm-8 pd-0">
                  <input
                    v-on:keyup="checkEnter"
                    v-model="dnmcSrch.ps"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label
                  class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03"
                  >Утас</label
                >
                <div class="col-sm-8 pd-0">
                  <input
                    v-on:keyup="checkEnter"
                    v-model="dnmcSrch.m"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-5-f" v-if="$store.state.app.activeGroup.id != 9344">
                <label
                  class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03"
                  >Регистр №</label
                >
                <div class="col-sm-8 pd-0">
                  <input
                    v-on:keyup="checkEnter"
                    v-model="dnmcSrch.rg"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label
                  class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03"
                  >И-мэйл</label
                >
                <div class="col-sm-8 pd-0">
                  <input
                    v-on:keyup="checkEnter"
                    v-model="dnmcSrch.ml"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Хайх утгаа оруулна уу"
                  />
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03">Хавчуурга</label>
                <div class="col-sm-8 pd-0">
                  <hrm-tag-assign
                          :fld="null"
                          :multiple="false"
                          v-model="filterParam.userTagCur"
                          @on-change="tagChosen"
                        ></hrm-tag-assign>
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03">Ажилбарын төрөл</label>
                <div class="col-sm-8 pd-0">
                  <Select v-model="filterParam.projId" clearable filterable @change="projChanged" class="wd-100p">
                    <Option v-for="(p, ci) in $store.state.app.groupDefaultProjects" :key="ci"
                     :value="p.objectTypeId" :label="p.title" ></Option>
                  </Select>
                </div>
              </div>
              <div class="form-group row mg-b-5-f">
                <label class="col-sm-4 pd-0 col-form-label d-flex align-items-center tx-color-03">Ажилбар</label>
                <div class="col-sm-8 pd-0">
                  <Select v-model="filterParam.taskId" clearable filterable @change="taskChanged" class="wd-100p">
                    <Option v-for="(t, ti) in filteredTasks" :key="ti"
                     :value="t.id" :label="t.task" ></Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="btn-group">
              <button
                @click="dnmcSrchDo()"
                class="btn btn-primary"
                type="submit"
              >
                Хайх
              </button>
              <button
                @click="dnmcSrchAll(dnmcSrch.activeTab)"
                class="btn btn-secondary"
                type="cancel"
              >
                Бүгд
              </button>
            </div>
            <button @click="refreshCCW()"
                class="btn bn-icon btn-warning mg-l-auto text-white"
                type="cancel"
              >
                <feather type="refresh-ccw"></feather>
              </button>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="d-flex pd-y-5 align-items-center">
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  @click="dnmcSrchAll(1)"
                  :class="
                    `btn btn-icon ${
                      userObj.users.list.length > 0 &&
                      users_filtered.length != userObj.users.list.length
                        ? 'btn-outline-danger'
                        : 'btn-outline-light'
                    } btn-xs`
                  "
                >
                  <feather type="x"></feather>
                </button>
              </div>
              <input
                v-model="filterParamUserTemp"
                class="form-control"
                type="text"
                placeholder="нэр эсвэл албан тушаалаар хайх"
                style="width: auto"
              />
              <div class="input-group-append">
                <button
                  @click="filterParam.user = filterParamUserTemp"
                  class="btn btn-icon btn-outline-light btn-xs"
                >
                  <feather type="search"></feather>
                </button>
              </div>
            </div>
            <span
              class="mg-l-auto pd-x-10"
              v-if="users_filtered.length != userObj.users.list.length"
              >{{ users_filtered.length }}/{{ userObj.users.list.length }}</span
            >
            <span class="mg-l-auto pd-x-10" v-else>{{
              userObj.users.list.length
            }}</span>
            <button
              @click="addGroupFiltered()"
              v-if="users_filtered.length"
              :class="
                `btn btn-icon btn-outline-light btn-xs d-flex align-items-center mg-l-5`
              "
            >
              <feather type="user-plus" class="mg-r-5"></feather>
              {{ users_filtered.length }}
            </button>
          </div>
          <virtual-list
            class="list-group p-sm"
            style="height: calc(100vh - 150px); overflow-y: auto;"
            :data-key="'id'"
            :data-sources="users_filtered"
            :data-component="ItemUser"
            :keeps="20"
            :estimate-size="15"
            @on-action="addUser"
          />
        </div>
        <div class="col-4">
          <div class="d-flex pd-y-5 align-items-center mg-l-10">
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  @click="
                    filterParam.member = '';
                    filterParamMemberTemp = '';
                  "
                  :class="
                    `btn btn-icon ${
                      userObj.selected.list.length > 0 &&
                      members_filtered.length != userObj.selected.list.length
                        ? 'btn-outline-danger'
                        : 'btn-outline-light'
                    } btn-xs`
                  "
                >
                  <feather type="x"></feather>
                </button>
              </div>
              <input
                v-model="filterParamMemberTemp"
                class="form-control"
                type="text"
                placeholder="нэр эсвэл албан тушаалаар хайх"
                style="width: auto"
              />
              <div class="input-group-append">
                <button
                  @click="filterParam.member = filterParamMemberTemp"
                  class="btn btn-icon btn-outline-light btn-xs"
                >
                  <feather type="search"></feather>
                </button>
              </div>
            </div>
            <span
              class="mg-l-auto pd-x-10"
              v-if="members_filtered.length != userObj.selected.list.length"
              >{{ members_filtered.length }}/{{
                userObj.selected.list.length
              }}</span
            >
            <span class="mg-l-auto pd-x-10" v-else>{{
              userObj.selected.list.length
            }}</span>
            <button
              @click="removeGroupFiltered()"
              v-if="members_filtered.length"
              :class="
                `btn btn-icon btn-outline-light btn-xs d-flex align-items-center mg-l-5`
              "
            >
              <feather type="user-minus" class="mg-r-5"></feather>
              {{ members_filtered.length }}
            </button>
          </div>
          <virtual-list
            class="list-group mg-l-10"
            style="height: calc(100vh - 150px); overflow-y: auto;"
            :data-key="'id'"
            :data-sources="members_filtered"
            :data-component="ItemMember"
            :keeps="20"
            :estimate-size="15"
            @on-action="removeUser"
          />
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="bd-t text-center">
        <div class="btn-group mg-y-7" role="group">
          <button
            @click="visibleChanged(false)"
            type="button"
            class="btn btn-xs btn-light"
          >
            Хаах
          </button>
          <button
            @click="postShareData()"
            type="button"
            class="btn btn-xs btn-light"
          >
            Хадгалах
          </button>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { projectPreShare } from "@/api/project";

import {
  getProjectShareData,
  postProjectSharedUserData
} from "@/api/user/projectInUser";
import { taskPreShare } from "@/api/task";
import {
  //getShareData,
  postShareData
} from "@/api/taskInUser";
import { request } from "@/api/all";
// import vueCustomScrollbar from "vue-custom-scrollbar";
import { mapActions } from "vuex";

import { Tree, Select, Option } from "element-ui";
var LTT = require("list-to-tree");
var _ = require("lodash");
const moment = require("moment");

import VirtualList from "vue-virtual-scroll-list";
import ItemUser from "./components/userVirtualTheme.vue";
import ItemMember from "./components/memberVirtualTheme.vue";

import { hasOneOf } from "@/libs/tools";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    // vueCustomScrollbar,
    Tree, Select, Option,
    "virtual-list": VirtualList,
    hrmTagAssign: () => ({
      component: import("@/components/task/edit/components/hrmTagAssign"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  name: "mentionUsers",
  props: {
    obj: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: () => false
    },
    showGroup: {
      type: Boolean,
      default: () => false
    },
    module: {
      type: String,
      default: () => ""
    },
    sharedUsers: {
      type: Array,
      default: () => []
    },
  },
  data: () => ({
    ItemUser: ItemUser,
    ItemMember: ItemMember,
    departsFlat: [],
    departs: [],
    defaultProps: {
      children: "children",
      label: "label",
      iid: "id"
    },

    showSidebar: false,
    groupObj: {
      group: {},
      groups: []
    },

    departObj: {
      departs: [],
      depart: {},
      show: false
    },
    userObj: {
      raw: {
        list: [],
        count: 0
      },
      users: {
        list: [],
        count: 0
      },
      selected: {
        list: [],
        count: 0
      }
    },
    filterParams: {
      groupId: null,
      departId: null,
      name: "",
      projId: null,
      taskId: null
    },
    filteredTasks: [],
    rdy: false,
    filterParamUserTemp: "",
    filterParamMemberTemp: "",
    filterParam: {
      user: "",
      user_ln: "",
      user_un: "",
      user_ps: "",
      user_m: "",
      user_rg: "",
      user_ml: "",

      userDepCur: null,
      locTypeId4: null,
      userTagCur: null,

      shareduids: [],

      userIds: [],
      member: "",
      member_ln: "",
      member_un: "",
      member_ps: "",
      member_m: "",
      member_rg: "",
      member_ml: ""
    },
    filterDepart: "",
    dnmcSrch: {
      activeTab: 1,
      un: "",
      ln: "",
      n: "",
      ps: "",
      m: "",
      rg: "",
      ml: ""
    },
    locTypeList4: []
  }),
  mounted() {
    //console.log('mention fired');
    //console.log('dsf9', this.module, this.obj.id);
  },
  watch: {
    filterDepart(val) {
      this.$refs.departTree.filter(val);
    },
    show: function(newVal) {
      if (newVal) {
        this.canMention();
      }
    }
  },
  methods: {
    ...mapActions(["handleLoading"]),
    handleStateSelect(e){
      //console.log('handleStateSelect', e);
      // if (e.length > 0) {
      //   this.srchModel.locTypeId4= e[0].id;
      //   e[0].expand = true;
      // } else {
      //   this.srchModel.locTypeId4= 0;
      // }
      // //this.sharingUsersFiltered();
      // this.filterListUsers();
      this.filterParam.locTypeId4 = e.id;
      //this.srchModel.locTypeId4= e.id;
    },
    loadStates(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Type/getTreeData" },
        params: { key: 'tmzUserState' },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res', res);
          let flatType = res.data.types;//.map(function(e){ e.title=e.s1; return e; });
          var lttType = new LTT(flatType, {
              key_id: "id",
              key_parent: "parentId",
              key_child: "children"
            });
            this.locTypeList4 = lttType.GetTree();
        }
      });
    },
    checkEnter(e) {
      if (e.keyCode === 13) {
        this.dnmcSrchDo();
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    canMention() {
      if (this.module == "project") {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "Project/PreStep" },
          params: { id: this.obj.id },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.initDeparts();
          } else {
            this.visibleChanged(false);
          }
        });
      } else {
        this.initDeparts();
      }
    },
    initDeparts() {
      //console.log('initDeparts fired');
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetDepartTreeData" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.departsFlat = res.data.departs;
          var ltt = new LTT(res.data.departs, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });
          this.departs = ltt.GetTree();
          this.init();
        }
      });
    },
    init() {
      //console.log('init mwntion=> ', this.module);
      this.showSidebar = true;
      switch (this.module) {
        case "project":
          this.toggleBodyClass("addClass", "dynamic-locker");
          projectPreShare({
            params: { projectId: this.obj.id },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.toggleBodyClass("addClass", "dynamic-locker");
              getProjectShareData({
                data: { taskId: this.obj.id },
                store: this.$store
              }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                this.userObj.users.list = res.data.groupUsers;
                this.userObj.selected.list = res.data.chosenUsers;
                //console.log('getProjectShareData', res.data);
                // this.userObj.raw.list = res.data.groupUsers;
                // this.userObj.selected.list = res.data.groupUsers.filter(
                //   x => x.chsn
                // );
                // this.filterUsers();
              });
            }
          });
          break;
        case "step": 
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: {
              method: "POST",
              url: "v2/ColumnInUser/GetShareData"
            },
            data: {
              columnId: this.obj.id,
              flag: this.obj.shareFlag
            },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log('st1', res, this.obj.id);
              this.userObj.users.list = res.data.groupUsers;
              this.userObj.selected.list = res.data.chosenUsers;
              this.loadStates();
            }
          });
        break;
        case "task":
          taskPreShare({
            params: { id: this.obj.id, projectId: this.obj.projectId },
            store: this.$store
          }).then(res => {
            //console.log('taskPreShare=> ', res);
            if (res != false) {
              this.toggleBodyClass("addClass", "dynamic-locker");
              request({
                api: { method: "post", url: "V2/TaskInUser/GetShareData" },
                data: {
                  taskId: this.obj.id,
                  locTypeId4: null,
                  flag: this.obj.shareFlag
                },
                store: this.$store
              }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  //console.log('st1', res, this.obj.id);
                  //console.log(res, this.obj.id);
                  this.userObj.users.list = res.data.groupUsers;
                  this.userObj.selected.list = res.data.chosenUsers;
                  //console.log(res, this.taskId);
                  // this.userObj.raw.list = res.data.groupUsers;

                  // if (this.taskId == 0) {
                  //   //this.userObj.selected.list = this.tempUsers;
                  // } else {
                  //   this.userObj.selected.list = res.data.groupUsers.filter(
                  //     x => x.chsn
                  //   );
                  // }

                  //this.filterUsers();
                  
                  this.loadStates();
                }
              });
            }else{
              this.visibleChanged(false);
            }
            // else {
            //   this.noPermission = true;
            // }
          });
          break;
        case "team":
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: {
              method: "post",
              url: "v2/team/GetShareData"
            },
            data: {
              teamId: this.obj.id,
              flag: this.obj.shareFlag
            },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log('st1', res, this.obj.id);
              this.userObj.users.list = res.data.groupUsers;
              this.userObj.selected.list = res.data.chosenUsers;
              this.loadStates();
            }
          });


          break;
        case "members":
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: {
              method: "post",
              url: "v2/TaskInUser/GetNotDynamicShareData"
            },
            data: {
              taskId: this.obj.id
            },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log(res, this.obj.id);
              //this.userObj.raw.list = res.data.groupUsers;
              this.userObj.users.list = res.data.groupUsers;
              this.userObj.selected.list = res.data.chosenUsers;
              // if (this.taskId == 0) {
              //   //this.userObj.selected.list = this.tempUsers;
              // } else {
              //   this.userObj.selected.list = res.data.groupUsers.filter(
              //     x => x.chsn
              //   );
              // }

              //this.filterUsers();

              this.loadStates();
            }
          });
          break;
        case "form":
          this.toggleBodyClass("removeClass", "dynamic-locker");
          request({
            api: { method: "post", url: "V2/FormInUser/GetShareData" },
            data: {
              taskId: this.obj.id,
              locTypeId4: null,
              flag: this.obj.shareFlag
            },
            store: this.$store
          }).then(res => {
            if (res != false) {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res != false) {
                //console.log('FormInUser/GetShareData', res);
                this.userObj.users.list = res.data.groupUsers;
                this.userObj.selected.list = res.data.chosenUsers;
                // this.rdy = true;
                // this.userObj.raw.list = res.data.groupUsers;
                // this.userObj.selected.list = res.data.groupUsers.filter(x => x.chsn);
                // this.filterUsers();
              }
            }
          });
          break;
        case "localMail":
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "V2/LocalMailInUser/GetShareData" },
            data: {
              //mailId: this.taskId, daraa ni noorogt hereg boln
              mailId: 0
              //flag: this.shareFlag
            },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log('LocalMailInUser', res);
              this.userObj.users.list = res.data.groupUsers;
              //this.userObj.selected.list= res.data.chosenUsers;
              //console.log('LocalMailInUser/GetShareData', res);
              // this.rdy = true;

              // this.userObj.raw.list = res.data.groupUsers;
              this.userObj.selected.list = this.sharedUsers;

              // this.userObj.raw.list = res.data.groupUsers;

              // this.filterParams.groupId = this.groupObj.group.id;
              // this.showDeparts();

              //this.filterUsers();
            }
          });
          break;

          case "file": 
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: {
                method: "POST",
                url: "v2/Media/GetFileSharedUserData"
              },
              data: {
                attachmentId: this.obj.id,
                flag: this.obj.shareFlag
              },
              store: this.$store
            }).then(res => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res != false) {
                //console.log('st1', res, this.obj.id);
                this.userObj.users.list = res.data.groupUsers;
                this.userObj.selected.list = res.data.chosenUsers;
                this.loadStates();
              }
            });
          break;
      }
    },
    filterUsers() {
      let self = this;
      if (this.filterParams.groupId != null) {
        this.userObj.users.list = this.userObj.raw.list.filter(
          x => x.gId == this.filterParams.groupId
        );
      } else {
        this.userObj.users.list = this.userObj.raw.list;
      }

      // if (this.filterParams.departId != null && this.departObj.show) {
      //   this.userObj.users.list = this.userObj.users.list.filter(
      //     x => x.dpId == this.filterParams.departId
      //   );
      // }

      // if (this.filterParams.name.length > 0) {
      //   this.userObj.users.list = this.userObj.users.list.filter(
      //     x =>
      //       x.n.toLowerCase().indexOf(self.filterParams.name.toLowerCase()) > -1
      //   );
      // }
      // if(this.mode!="task" && this.mode!="members"){
      //   this.userObj.selected.list.forEach(function(e) {
      //     let i = -1;
      //     if (self.userObj.users.list.filter(x => x.id == e.id).length > 0) {
      //       i = self.userObj.users.list
      //         .map(u => {
      //           return u.id;
      //         })
      //         .indexOf(e.id);
      //     }

      //     if (i > -1) self.userObj.users.list.splice(i, 1);
      //   });
      // }
    },
    departNodeClicked(depId) {
      //console.log('end neg vv');
      this.filterParam.userDepCur = depId;
      // let self= this;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetUserIdsByDepartId" },
        params: {
          departId: depId,
          tagId: this.filterParam.userTagCur,
          systemFlag: this.module == "members" ? 6 : 1,
          gid: this.filterParams.groupId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log(res);
          this.filterParam.userIds = res.data.userIds.map(x => {
            return x.userId;
          });
          // res.data.childDeparts.map((d)=>{ return d.id }).forEach((d)=>{
          //   self.userObj.users.list = self.userObj.users.list.concat(
          //     self.userObj.selected.list.filter(x => x.dpId == d)
          //   );
          //   self.userObj.selected.list = self.userObj.selected.list.filter(
          //     x => x.dpId != d
          //   );
          // })
        }
      });
      //this.sortList(-1);

      //console.log('departNodeClicked=> ', depId, this.filterParam.userDepCur);
    },
    tagChosen(tagId) {

      //console.log(tagId);

      if(tagId==undefined || tagId=="")
        this.filterParam.userTagCur = null;
      else
        this.filterParam.userTagCur = tagId;
      // let self= this;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetUserIdsByDepartId" },
        params: {
          departId: this.filterParam.userDepCur,
          tagId: tagId,
          systemFlag: this.module == "members" ? 6 : 1,
          gid: this.filterParams.groupId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log(res);
          this.filterParam.userIds = res.data.userIds.map(x => {
            return x.userId;
          });
          // res.data.childDeparts.map((d)=>{ return d.id }).forEach((d)=>{
          //   self.userObj.users.list = self.userObj.users.list.concat(
          //     self.userObj.selected.list.filter(x => x.dpId == d)
          //   );
          //   self.userObj.selected.list = self.userObj.selected.list.filter(
          //     x => x.dpId != d
          //   );
          // })
        }
      });
      //this.sortList(-1);

      //console.log('departNodeClicked=> ', depId, this.filterParam.userDepCur);
    },
    addGroup(dp) {
      let self = this;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetUserIdsByDepartId" },
        params: {
          departId: dp,
          systemFlag: 1,
          gid: this.filterParams.groupId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          res.data.childDeparts
            .map(d => {
              return d.id;
            })
            .forEach(d => {
              self.userObj.selected.list = self.userObj.selected.list.concat(
                self.userObj.users.list.filter(x => x.dpId == d)
              );
              self.userObj.users.list = self.userObj.users.list.filter(
                x => x.dpId != d
              );
            });
        }
      });
      this.sortList(1);
    },
    addGroupFiltered() {
      let _arr = this.users_filtered.map(x => {
        return x.key;
      });
      this.userObj.selected.list = this.userObj.selected.list.concat(
        this.users_filtered
      );
      this.userObj.users.list = this.userObj.users.list.filter(
        x => !hasOneOf(_arr, [x.key])
      );
      this.sortList(1);
      this.filterParam.user = "";
      this.filterParamUserTemp = "";
    },
    addUser(id) {
      this.userObj.selected.list = this.userObj.selected.list.concat(
        this.userObj.users.list.filter(x => x.id == id)
      );
      this.userObj.users.list = this.userObj.users.list.filter(x => x.id != id);
      this.sortList(1);
    },
    removeGroup(dp) {
      let self = this;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetUserIdsByDepartId" },
        params: {
          departId: dp,
          systemFlag: 1,
          gid: this.filterParams.groupId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          res.data.childDeparts
            .map(d => {
              return d.id;
            })
            .forEach(d => {
              self.userObj.users.list = self.userObj.users.list.concat(
                self.userObj.selected.list.filter(x => x.dpId == d)
              );
              self.userObj.selected.list = self.userObj.selected.list.filter(
                x => x.dpId != d
              );
            });
        }
      });
      this.sortList(-1);
    },
    removeGroupFiltered() {
      let _arr = this.members_filtered.map(x => {
        return x.key;
      });
      this.userObj.users.list = this.userObj.users.list.concat(
        this.members_filtered
      );
      this.userObj.selected.list = this.userObj.selected.list.filter(
        x => !hasOneOf(_arr, [x.key])
      );
      this.sortList(-1);
      this.filterParam.member = "";
      this.filterParamMemberTemp = "";
    },
    removeUser(id) {
      this.userObj.users.list = this.userObj.users.list.concat(
        this.userObj.selected.list.filter(x => x.id == id)
      );
      this.userObj.selected.list = this.userObj.selected.list.filter(
        x => x.id != id
      );
      this.sortList(-1);
    },
    sortList(m) {
      //console.log(this.userObj.selected.list)
      if (m == 1)
        this.userObj.selected.list = _.orderBy(
          this.userObj.selected.list,
          "n",
          "asc"
        );
      if (m == -1)
        this.userObj.users.list = _.orderBy(
          this.userObj.users.list,
          "n",
          "asc"
        );
    },
    postShareData() {
      let _ta = [];

      _ta = this.userObj.selected.list.map(u => {
        return u.key;
      });

      switch (this.module) {
        case "project":
          this.toggleBodyClass("addClass", "dynamic-locker");
          postProjectSharedUserData({
            data: { taskId: this.obj.id, sharedUsers: _ta },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            this.$bvToast.toast(
              `Нэмсэн: ${res.data.addedCount}. Хассан: ${res.data.removedCount}. Сонгосон: ${_ta.length}`,
              {
                title: "Амжилттай",
                autoHideDelay: 500,
                appendToast: true,
                variant: "success",
                toaster: "b-toaster-bottom-left"
              }
            );
            this.visibleChanged(false);
          });
          break;
        case "step": 
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "POST", url: "ColumnInUser/PostShareData" },
              data: { 
                //teamId: rest.data.id, flag: 0, sharedUserTaskIds: _ta, 

                taskId: this.obj.id,
                executaFlag: 0,
                sharedUsers: _ta  
              },
              store: this.$store
            }).then(res => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res != false) {
                this.$bvToast.toast(
                  `Нэмсэн: ${res.data.addedCount}. Хассан: ${res.data.removedCount}. Сонгосон: ${_ta.length}`,
                  {
                    title: "Амжилттай",
                    autoHideDelay: 500,
                    appendToast: true,
                    variant: "success",
                    toaster: "b-toaster-bottom-left"
                  }
                );
                this.visibleChanged(false);
              }
            });
        break;

        case "task":
          this.toggleBodyClass("addClass", "dynamic-locker");
          postShareData({
            data: { taskId: this.obj.id, executaFlag: 1, sharedUsers: _ta },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.visibleChanged(false);
              this.$emit("on-force");
            }
          });
          break;
        case "team":
          this.toggleBodyClass("addClass", "dynamic-locker");
          
          _ta = this.userObj.selected.list.map(u => { return u.id; });


          if(this.obj.id==0){
            let _prms= { team: moment(new Date()).format("YYYY-MM-DD HH:mm"), flag: 0};

            if(_ta.length==1){
              _prms= { team: "_#system", flag: -1, toUserTaskId: _ta[0] };
            }

            request({
              api: { method: "POST", url: "team/CreateTeam" },
              data: _prms,
              store: this.$store
            }).then(rest => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (rest != false) {
                // this.visibleChanged(false);
                // this.$emit("on-force");
                if(_ta.length==1){
                  this.visibleChanged(false);
                  this.$emit("on-composed", rest.data.id);
                }else{
                  this.toggleBodyClass("addClass", "dynamic-locker");
                  request({
                    api: { method: "POST", url: "team/PostShareData" },
                    data: { teamId: rest.data.id, flag: 0, sharedUserTaskIds: _ta },
                    store: this.$store
                  }).then(res => {
                    this.toggleBodyClass("removeClass", "dynamic-locker");
                    if (res != false) {
                      this.visibleChanged(false);
                      this.$emit("on-composed", rest.data.id);
                    }
                  });
                }
              }
            });
          } else{
            request({
              api: { method: "POST", url: "team/PostShareData" },
              data: { teamId: this.obj.id, flag: 0, sharedUserTaskIds: _ta },
              store: this.$store
            }).then(res => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res != false) {
                this.visibleChanged(false);
                this.$emit("on-force");
              }
            });
          }
          break;
        case "members":
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: {
              method: "POST",
              url: "TaskInUser/PostNotDynamicUserShareData"
            },
            data: { taskId: this.obj.id, executaFlag: 0, sharedUsers: _ta },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.visibleChanged(false);
              this.$emit("on-force");
            }
          });

          // postShareData({
          //   data: { taskId: this.obj.id, executaFlag: 1, sharedUsers: _ta },
          //   store: this.$store
          // }).then(res => {
          //   if (res != false) {
          //     this.visibleChanged(false);
          //     this.$emit("on-force");
          //   }
          // });
          break;

        case "form":
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "FormInUser/PostShareData" },
            store: this.$store,
            data: {
              taskId: this.obj.id,
              executaFlag: 1,
              sharedUsers: _ta,
              flag: this.obj.shareFlag
            }
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            // this.users.forEach(e => {
            //   e.chk = false;
            // });
            // this.confirmModel.id = 0;
            // this.visibleChanged(false);
            // this.$emit("on-mention");
            // this.$Message.success("Амжилттай хадгаллаа.");
            if (res != false) {
              this.$bvToast.toast(
                `Нэмсэн: ${res.data.addedCount}. Хассан: ${res.data.removedCount}. Сонгосон: ${_ta.length}`,
                {
                  title: "Амжилттай",
                  autoHideDelay: 500,
                  appendToast: true,
                  variant: "success",
                  toaster: "b-toaster-bottom-left"
                }
              );
              this.visibleChanged(false);
              this.$emit("on-force");
            }
          });
          break;
        case "localMail":
          this.$emit("on-mention", this.userObj.selected.list);
          //console.log(this.userObj.selected.list);
          //this.$emit("on-mention", this.userObj.selected.list.map(u => { return u.id; }));
          this.visibleChanged(false);
          break;
        case "file":
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "post", url: "Media/PostFileSharedUserData" },
            store: this.$store,
            data: {
              taskId: this.obj.id,
              executaFlag: 1,
              sharedUsers: _ta,
            }
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.$bvToast.toast(
                `Нэмсэн: ${res.data.addedCount}. Хассан: ${res.data.removedCount}. Сонгосон: ${_ta.length}`,
                {
                  title: "Амжилттай",
                  autoHideDelay: 500,
                  appendToast: true,
                  variant: "success",
                  toaster: "b-toaster-bottom-left"
                }
              );
              this.visibleChanged(false);
              this.$emit("on-force");
            }
          });
          break;
        default: {
          break;
        }
      }
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.showSidebar = false;
        this.$emit("on-mention-close");
      }
    },
    dnmcSrchDo() {
      if (this.dnmcSrch.activeTab == 1) {
        this.filterParam.user = this.filterParamUserTemp;
        this.filterParam.user_un = this.dnmcSrch.un;
        this.filterParam.user_ln = this.dnmcSrch.ln;
        this.filterParam.user_ps = this.dnmcSrch.ps;
        this.filterParam.user_m = this.dnmcSrch.m;
        this.filterParam.user_rg = this.dnmcSrch.rg;
        this.filterParam.user_ml = this.dnmcSrch.ml;
      } else {
        this.filterParam.member = this.filterParamMemberTemp;
        this.filterParam.member_un = this.dnmcSrch.un;
        this.filterParam.member_ln = this.dnmcSrch.ln;
        this.filterParam.member_ps = this.dnmcSrch.ps;
        this.filterParam.member_m = this.dnmcSrch.m;
        this.filterParam.member_rg = this.dnmcSrch.rg;
        this.filterParam.member_ml = this.dnmcSrch.ml;
      }
    },
    dnmcSrchAll(at) {
      this.dnmcSrch.un = "";
      this.dnmcSrch.ln = "";
      this.dnmcSrch.n = "";
      this.dnmcSrch.ps = "";
      this.dnmcSrch.m = "";
      this.dnmcSrch.rg = "";
      this.dnmcSrch.ml = "";

      if (this.dnmcSrch.activeTab == 1) {
        this.filterParamUserTemp = "";
        this.filterParam.user = "";
        this.filterParam.user_un = "";
        this.filterParam.user_ln = "";
        this.filterParam.user_ps = "";
        this.filterParam.user_m = "";
        this.filterParam.user_rg = "";
        this.filterParam.user_ml = "";

        this.filterParam.projId= null;
        this.filterParam.taskId= null;
        this.filterParam.shareduids= [];
        this.filterParam.locTypeId4= null;

        this.filterParam.userDepCur= null;
        this.filterParam.userIds= [];
      } else {
        this.filterParamMemberTemp = "";
        this.filterParam.member = "";
        this.filterParam.member_un = "";
        this.filterParam.member_ln = "";
        this.filterParam.member_ps = "";
        this.filterParam.member_m = "";
        this.filterParam.member_rg = "";
        this.filterParam.member_ml = "";
      }

      this.dnmcSrch.activeTab = at;
    },
    refreshCCW(){
      const _from= JSON.parse(JSON.stringify(this.userObj.selected.list));
      const _to= JSON.parse(JSON.stringify(this.userObj.users.list));

      this.userObj.selected.list = _to;
      this.userObj.users.list = _from;
    },
    projChanged(e){
      //console.log(e);
      request({
        api: { url: "task/getTasksByOT", method: "get" },
        params: { ot: e, size: 100, page: 0, parentId: 0 },
        store: this.$store
      }).then(res => {
        //console.log(res.data.tasks.length);
        this.filteredTasks = res.data.tasks.filter(x => x.parentId == 0);
      });
    },
    taskChanged(e){
      //console.log(e);
      request({
        api: { url: "TaskInUser/GetSharedUserIds", method: "get" },
        params: { taskId: e },
        store: this.$store
      }).then(res => {
        this.filterParam.shareduids= res.data.list;
        //console.log(res.data.list);
      });
    }
  },
  computed: {
    users_filtered: function() {
      //console.log('this.filterParam.locTypeId4', this.filterParam.locTypeId4);
      let self = this;
      let _un = self.filterParam.user_un.toLowerCase();
      let _ln = self.filterParam.user_ln.toLowerCase();
      let val = self.filterParam.user.toLowerCase();
      let _ps = self.filterParam.user_ps.toLowerCase();
      let _m = self.filterParam.user_m.toLowerCase();
      let _rg = self.filterParam.user_rg.toLowerCase();
      let _ml = self.filterParam.user_ml.toLowerCase();

      //if(this.module=="team"){
        //return this.userObj.users.list;
      //}
      //else {
        return this.userObj.users.list.filter(u => {
          //console.log(u)
          return (
            //u.n.toLowerCase().indexOf(val) > -1 || (u.ps!=null && u.ps.toLowerCase().indexOf(val) > -1)
            u.n.toLowerCase().indexOf(val) > -1 &&
            u.ln != null &&
            u.un.toLowerCase().indexOf(_un) > -1 &&
            u.ln != null &&
            u.ln.toLowerCase().indexOf(_ln) > -1 &&
            u.ps != null &&
            u.ps.toLowerCase().indexOf(_ps) > -1 &&
            u.m != null &&
            u.m.toLowerCase().indexOf(_m) > -1 &&
            u.rg != null &&
            u.rg.toLowerCase().indexOf(_rg) > -1 &&
            u.ml != null &&
            u.ml.toLowerCase().indexOf(_ml) > -1 &&
            (this.filterParam.userIds.length == 0 &&
            this.filterParam.userDepCur == null
              ? true
              : hasOneOf(this.filterParam.userIds, [u.key]))
              
            && (
              //lt4Id
              this.filterParam.locTypeId4==null? true :  ( u.st==this.filterParam.locTypeId4 ? true : false )
              // (this.filterParam.locTypeId4!=null &&
              // u.st==this.filterParam.locTypeId4)?true:false
            )

            && (this.filterParam.shareduids.length==0? true : hasOneOf(this.filterParam.shareduids, [u.key]) )
          );
        });
      //}
    },
    members_filtered: function() {
      //console.log('members_filtered');
      let self = this;
      let _un = self.filterParam.member_un.toLowerCase();
      let _ln = self.filterParam.member_ln.toLowerCase();
      let val = self.filterParam.member.toLowerCase();
      let _ps = self.filterParam.member_ps.toLowerCase();
      let _m = self.filterParam.member_m.toLowerCase();
      let _rg = self.filterParam.member_rg.toLowerCase();
      let _ml = self.filterParam.member_ml.toLowerCase();

      //return [];

      if(this.module=="team"){
        return this.userObj.selected.list;
      }else{
        return this.userObj.selected.list.filter(u => {
          //return u.n.toLowerCase().indexOf(val) > -1 || (u.ps!=null && u.ps.toLowerCase().indexOf(val) > -1);
          return (
            u.n.toLowerCase().indexOf(val) > -1 &&
            u.ln != null &&
            u.un.toLowerCase().indexOf(_un) > -1 &&
            u.ln != null &&
            u.ln.toLowerCase().indexOf(_ln) > -1 &&
            u.ps != null &&
            u.ps.toLowerCase().indexOf(_ps) > -1 &&
            u.m != null &&
            u.m.toLowerCase().indexOf(_m) > -1 &&
            u.rg != null &&
            u.rg.toLowerCase().indexOf(_rg) > -1 &&
            u.ml != null &&
            u.ml.toLowerCase().indexOf(_ml) > -1
          );
        });
      }
    }
  }
};
</script>

<style lang="scss">
.depart-tree {
  .el-tree-node {
    white-space: inherit !important;
    outline: 0 !important;
    // height: 40px;
    .el-tree-node__content {
      padding-top: 5px !important;
      padding-bottom: 5px !important;
      height: auto;
      line-height: 1.4;
      // height: 40px;
    }
  }
}
</style>
